import { Price } from '../types';

export const numberToPrice = (v: number): Price => ({
  min: v,
  max: v,
  fallback: v,
});
